module.exports = __webpack_public_path__ + "static/media/71.df3b52fd.jpg";